import React from 'react'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Select from 'react-select';
import Api from '../../../../utils/api'

class Location extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props.state,
      selectedOption: null,
      selectedAddressOption: null,
      addressOptions: [],
      addressLoading: false,
      addressInputValue: this.props.state.data.address || ''
    };
    this.setData = this.props.setData;
    this.district = this.props.general.district.map(item => ({ label: item.name, value: item.id.toString() }));
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const district = nextProps.state.data.district;
    const address = nextProps.state.data.address || '';

    this.setState({
      ...nextProps.state,
      selectedOption: !!district ? this.district.find(item => item.value === district.toString()) : null,
      selectedAddressOption: address ? { label: address, value: address } : null,
      addressInputValue: address
    });
  }

  selectAddressSearchBox = (option) => {
    if (!option || !option.raw) {
      return;
    }

    const suggestion = option.raw.data || {};
    const house = suggestion.house != null ? String(suggestion.house) : '';
    const flat = suggestion.flat != null ? String(suggestion.flat) : '';

    const fullAddress = [
      suggestion.city_with_type,
      suggestion.street_with_type,
      (suggestion.house_type ? suggestion.house_type : '') + (house ? ' ' + house : ''),
      (suggestion.block_type ? suggestion.block_type : '') + (suggestion.block ? ' ' + suggestion.block : ''),
      flat ? ((suggestion.flat_type ? suggestion.flat_type : 'кв') + ' ' + flat) : ''
    ]
      .map(item => (item || '').trim())
      .filter(Boolean)
      .join(', ');

    this.setData('houseNumber', house ? parseInt(house, 10) || '' : '');
    this.setData('houseLetter', house ? house.replace(/[0-9]/ig, "") : '');
    this.setData('flatNumber', flat || '');
    this.setData('houseCorpse', suggestion.block != null ? suggestion.block : '');
    this.setData('street', suggestion.street != null ? suggestion.street : '');
    this.setData('metro', suggestion.metro != null ? suggestion.metro : '');
    this.setData('address', fullAddress);
    this.setData('addressKladrId', suggestion.kladr_id || '');
    this.setData('fiasId', suggestion.fias_id || '');
    this.setData('latitude', suggestion.geo_lat || '');
    this.setData('longitude', suggestion.geo_lon || '');
    this.setData('cityDistrict', suggestion.city_district || suggestion.city_area || '');

    this.setState({
      selectedAddressOption: { label: fullAddress, value: fullAddress },
      addressInputValue: fullAddress,
      addressOptions: []
    });
  }

  fetchAddressOptions = (query) => {
    if (!query || query.length < 3) {
      this.setState({ addressOptions: [], addressLoading: false });
      return;
    }

    this.setState({ addressLoading: true });

    Api.get('/geo/address?name=' + encodeURIComponent(query))
      .then(out => {
        const options = (out.value || [])
          .slice(0, 5)
          .map(item => {
            const text = [
              item.data.city_with_type,
              item.data.street_with_type,
              (item.data.house_type ? item.data.house_type : '') + (item.data.house ? ' ' + item.data.house : ''),
              (item.data.block_type ? item.data.block_type : '') + (item.data.block ? ' ' + item.data.block : ''),
              item.data.flat ? ((item.data.flat_type ? item.data.flat_type : 'кв') + ' ' + item.data.flat) : ''
            ].map(cell => (cell || '').trim()).filter(Boolean).join(', ');

            return {
              label: text,
              value: item.data.kladr_id || text,
              raw: item
            };
          });

        this.setState({
          addressOptions: options,
          addressLoading: false
        });
      })
      .catch(() => {
        this.setState({ addressLoading: false });
      });
  }

  onAddressInputChange = (value, meta) => {
    if (meta && meta.action !== 'input-change') {
      return value;
    }

    this.setState({
      addressInputValue: value,
      selectedAddressOption: null
    });

    this.setData('address', value);
    this.setData('addressKladrId', '');
    this.setData('fiasId', '');
    this.setData('latitude', '');
    this.setData('longitude', '');
    this.setData('cityDistrict', '');

    clearTimeout(this.addressSearchTimer);
    this.addressSearchTimer = setTimeout(() => this.fetchAddressOptions(value), 350);

    return value;
  }

  isInvalid = (field) => {
    return Array.isArray(this.props.invalidFields) && this.props.invalidFields.indexOf(field) !== -1;
  }

  address(required, text = "Адрес") {
    return (
      <label>
        <div className={`title ${required} ${this.isInvalid('address') ? 'text-danger' : ''}`}>{text}</div>
        <div className="value" style={{ minWidth: 360 }}>
          <Select
            classNamePrefix="address-select"
            isSearchable={true}
            placeholder="Начните вводить адрес (минимум 3 символа)"
            noOptionsMessage={() => this.state.addressInputValue.length < 3 ? 'Введите минимум 3 символа' : 'Ничего не найдено'}
            loadingMessage={() => 'Поиск...'}
            options={this.state.addressOptions}
            isLoading={this.state.addressLoading}
            value={this.state.selectedAddressOption}
            inputValue={this.state.addressInputValue}
            onInputChange={this.onAddressInputChange}
            onChange={this.selectAddressSearchBox}
            filterOption={null}
          />
        </div>
      </label>
    )
  }

  city(required) {
    let data = this.state.data;
    return (
      <label>
        <div className={`title ${required}`}>Город</div>
        <div className="value">
          {data.city}
        </div>
      </label>
    )
  }

  location(required) {
    let data = this.state.data;
    return (
      <label>
        <div className={`title ${required}`}>Расположение</div>
        <div className="value">
          <select className="custom-select custom-select-sm" value={data.location} onChange={(e) => this.setData('location', parseInt(e.target.value))}>
            <option value="">Выберите...</option>
            {this.props.general.location.map(item => <option value={item.id} key={item.id}>{item.name}</option>)}
          </select>
        </div>
      </label>
    )
  }

  area(required) {
    let data = this.state.data;
    return (
      <label>
        <div className={`title ${required} ${this.isInvalid('district') ? 'text-danger' : ''}`}>Район</div>
        <div className="value">
          <Select
            onChange={(e) => { this.setData('district', e.value); }}
            options={this.district}
            isSearchable={true}
            className={'w-25'}
            value={this.state.selectedOption}
            name="district"
            placeholder="Выберите..." />
        </div>
      </label>
    )
  }

  street(required, text = "Улица") {
    let data = this.state.data;
    return (
      <label>
        <div className={`title ${required} ${this.isInvalid('street') ? 'text-danger' : ''}`}>{text}</div>
        <div className="value">
          <input className={`form-control form-control-sm ${this.isInvalid('street') ? 'is-invalid' : ''}`} type="text" value={data.street || ''} readOnly />
        </div>
      </label>
    )
  }

  cadastral(required) {
    let data = this.state.data;
    return (
      <label>
        <div className={`title ${required} ${this.isInvalid('cadastral') ? 'text-danger' : ''}`}>Кадастровый номер</div>
        <div className="value">
          <input className={`form-control form-control-sm ${this.isInvalid('cadastral') ? 'is-invalid' : ''}`} onChange={(e) => this.setData('cadastral', e.target.value)} type="text" value={data.cadastral} />
        </div>
      </label>
    )
  }

  metro(required) {
    let data = this.state.data;
    return (
      <label>
        <div className={`title ${required}`}>Метро</div>
        <div className="value">
          <input className="form-control form-control-sm" onChange={(e) => this.setData('metro', e.target.value)} type="text" value={data.metro} />
        </div>
      </label>
    )
  }

  houseNumber(required, text = "Дом") {
    let data = this.state.data;
    return (
      <label>
        <div className={`title ${required} ${this.isInvalid('houseNumber') ? 'text-danger' : ''}`}>{text}</div>
        <div className="value">
          <input className={`form-control form-control-sm ${this.isInvalid('houseNumber') ? 'is-invalid' : ''}`} type="text" value={data.houseNumber || ''} readOnly />
        </div>
      </label>
    )
  }

  houseLetter() {
    let data = this.state.data;
    return (
      <label>
        <div className="title">Буква</div>
        <div className="value">
          {data.houseLetter}
        </div>
      </label>
    )
  }

  houseCorpse() {
    let data = this.state.data;
    return (
      <label>
        <div className="title">Корпус</div>
        <div className="value">
          {data.houseCorpse}
        </div>
      </label>
    )
  }

  flatNumber(required) {
    let data = this.state.data;
    const user = this.props.user;
    return (
      <>
        {(data.realtor === user.id || !this.props.isEdit) &&
          <label>
            <div className={`title ${required}`}>Квартира</div>
            <div className="value">
              <input className="form-control form-control-sm small-input" type="text" value={data.flatNumber} onChange={(e) => this.setData('flatNumber', e.target.value)} />
            </div>
          </label>
        }
      </>
    )
  }

  landNumber() {
    let data = this.state.data;
    const user = this.props.user;
    return (
      (data.realtor === user.id || !this.props.isEdit) && (
        <label>
          <div className={`title${!data.isStudio ? " required" : ""} ${this.isInvalid('landNumber') ? 'text-danger' : ''}`}>Номер участка</div>
          <div className="value">
            <input className={`form-control form-control-sm small-input ${this.isInvalid('landNumber') ? 'is-invalid' : ''}`} type="number" value={data.landNumber} onChange={(e) => this.setData('landNumber', parseInt(e.target.value) || 0)} />
          </div>
        </label>
      )
    )
  }

  gardenCommunity() {
    let data = this.state.data;
    return (
      <label>
        <div className="title">В садовом обществе</div>
        <div className="value">
          <input type="checkbox" checked={data.isGardenCommunity} onChange={(e) => this.setData('isGardenCommunity', +e.target.checked)} />
        </div>
      </label>
    )
  }

  inCity() {
    let data = this.state.data;
    return (
      <label>
        <div className="title">В городе</div>
        <div className="value">
          <input type="checkbox" checked={data.isInCity} onChange={(e) => this.setData('isInCity', +e.target.checked)} />
        </div>
      </label>
    )
  }

  renderParams(type) {

    switch (parseInt(type)) {
      case 1:
        return (
          <>
            <div className="input-group">
              {this.address("required")}
              {this.area("required")}
              {this.metro()}
            </div>
            <div className="input-group">
              {/*this.city("required")*/}
              {/*this.street("required")*/}
              {/*this.houseNumber("required")*/}
              {/*this.houseLetter()*/}
              {/*this.houseCorpse()*/}
            </div>
            <div className="input-group">
              {this.flatNumber()}
              {this.cadastral()}
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="input-group">
              {this.city("required")}
              {this.area("required")}
              {this.street("required")}
              {this.metro()}
            </div>
            <div className="input-group">
              {this.houseNumber("required")}
              {this.houseLetter()}
              {this.houseCorpse()}
              {this.flatNumber("required")}
              {this.cadastral()}
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div className="input-group">
              {this.city("required")}
              {/*{ this.location() }*/}
              {/*{this.gardenCommunity()}*/}
              {/*{this.inCity()}*/}
              {this.cadastral("required")}
            </div>
            <div className="input-group">
              {this.area("required")}
              {this.street("required")}
              {this.houseNumber("required")}
              {this.houseLetter()}
              {/*{this.houseCorpse()}*/}
              {/*{this.flatNumber()}*/}
            </div>
          </>
        );
      case 4:
        return (
          <>
            <div className="input-group">
              {this.city("required")}
              {this.area("required")}
              {this.metro()}
              {this.cadastral()}
            </div>
            <div className="input-group">
              {this.location("required")}
              {this.street("required")}
              {this.houseNumber("required")}
              {this.houseLetter()}
              {this.houseCorpse()}
              {/*{this.flatNumber()}*/}
            </div>
          </>
        );
      case 5:
        return (
          <>
            <div className="input-group">
              {this.city("required")}
              {this.area("required")}
              {this.metro()}
              {this.cadastral()}
            </div>
            <div className="input-group">
              {this.location("required")}
              {this.street("required", "Вблизи улицы")}
              {this.houseNumber("required", "Номер")}
              {this.houseLetter()}
            </div>
          </>
        )
      case 6:
        return (
          <>
            <div className="input-group">
              {this.city("required")}
              {this.cadastral("required")}
            </div>
            <div className="input-group">
              {this.area("required")}
              {this.street("required")}
              {this.landNumber()}
            </div>
          </>
        );
    }

  }



  render = () => {

    return (
      <>
        {this.renderParams(this.state.data.type)}
      </>
    )
  }
}

const mapStateToProps = ({ user, general, seller, router }) => ({
  user,
  general,
  seller,
  location: router.location
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: (page) => push(page)
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Location)
